import React, { Fragment } from "react";
import { ReactSVG } from "react-svg";
import { Menu, Transition } from "@headlessui/react";

const ActionsMenu = ({ onEdit = () => {}, onDelete = () => {}, className = "" }) => {
  return (
    <div className={className}>
      <div className="flex justify-center">
        <Menu as="div" className="relative inline-block text-left">
          {({ open }) => (
            <>
              <div>
                <Menu.Button>
                  <ReactSVG src={`/icons/triple-dot.svg`} className="w-6 scale-x-[1.4] scale-y-[1.4]" />
                </Menu.Button>
              </div>
              <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform translate-y-2 opacity-0 scale-95"
                enterTo="transform translate-y-0 opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform translate-y-0 opacity-100 scale-100"
                leaveTo="transform translate-y-2 opacity-0 scale-95"
              >
                <Menu.Items className="absolute left-[-6px] min-w-[100px] w-auto origin-top bg-white divide-y divide-gray-100 rounded-md shadow-lg ring-1 ring-black ring-opacity-5 mt-0">
                  <Menu.Item>
                    {() => (
                      <button
                        className="block w-full text-left h-[30px] px-2.5 py-2.5 flex items-center gap-2 hover:bg-gray-50"
                        onClick={onEdit}
                      >
                        Edit
                      </button>
                    )}
                  </Menu.Item>
                  <Menu.Item>
                    {() => (
                      <button
                        className="block w-full text-left h-[30px] px-2.5 py-2.5 flex items-center gap-2 hover:bg-gray-50"
                        onClick={onDelete}
                      >
                        Delete
                      </button>
                    )}
                  </Menu.Item>
                </Menu.Items>
              </Transition>
            </>
          )}
        </Menu>
      </div>
    </div>
  );
};

export default ActionsMenu;
